module.exports = __webpack_public_path__ + "h5/img/4.06603da3.png";